import React, { useEffect, useState } from 'react';
import './Userguide.css';
import Header from './Header';
import Footer from './Footer';

const pdfIcon = "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg";

const Userguide = () => {
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = '/path/to/user-guide.pdf';
        link.download = 'User_Guide.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [tutorials, setTutorials] = useState([]);

    useEffect(() => {
        const fetchTutorials = async () => {
            try {
                const response = await fetch('https://api.ndtechland.com/api/HomeApi/GetOurTutorials');
                const data = await response.json();

                if (data.status === 200) {
                    setTutorials(data.data);
                } else {
                    console.error('Error fetching tutorials:', data.message);
                }
            } catch (error) {
                console.error('Error fetching tutorials:', error);
            }
        };

        fetchTutorials();
    }, []);

    return (
        <div>
            <Header />

            <div className="nd-guide-page">
                <div className="nd-guide-container container">
                    {/* Hero Header */}
                    <div className="nd-guide-hero">
                        <div className="nd-guide-badge">Documentation & Tutorials</div>
                        <h1 className="nd-guide-title">User Guide</h1>
                        <p className="nd-guide-subtitle">
                            Watch video tutorials and download resources to easily configure and get the most out of N D Connect.
                        </p>
                    </div>

                    {/* PDF Guide Download Card */}
                    <div className="nd-guide-pdf-card" onClick={handleDownload}>
                        <div className="nd-guide-pdf-left">
                            <img src={pdfIcon} alt="PDF Icon" className="nd-guide-pdf-icon" />
                            <div className="nd-guide-pdf-info">
                                <h3>Download User Guide (PDF)</h3>
                                <p>Click to download the full user guide in PDF format.</p>
                            </div>
                        </div>
                        <span className="nd-guide-download-btn">
                            📥 Download PDF
                        </span>
                    </div>

                    {/* Video Tutorials Section */}
                    <div className="nd-guide-section-head">
                        <h2>Video Tutorials</h2>
                    </div>

                    <div className="nd-guide-tutorial-grid">
                        {tutorials.length > 0 ? (
                            tutorials.map(tutorial => (
                                <div className="nd-guide-tutorial-card" key={tutorial.id}>
                                    <div className="nd-guide-video-frame">
                                        <iframe
                                            src={`https://api.ndtechland.com/TutorialVideos/${tutorial.vedioUrl}`}
                                            title={tutorial.title}
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                    <div className="nd-guide-card-content">
                                        <h3>{tutorial.title}</h3>
                                        <p>{tutorial.description}</p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="nd-guide-loading">
                                Loading video tutorials...
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Userguide;
